import { BrowserModule, Title } from '@angular/platform-browser'
import { HttpClientModule } from '@angular/common/http'
import { APOLLO_OPTIONS } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import { ApolloLink, InMemoryCache } from '@apollo/client/core'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { AppComponent } from './app.component'
import { setContext } from '@apollo/client/link/context'
import { RouterModule } from '@angular/router'
import { HomeGuard } from './page/page.home.component.guard'
import { PageComponent } from './page/page.component'
import { SettingsService } from './srv/settings.service'
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics'

const uri = 'https://graphql.datocms.com'
const token = '3596d8f447eaa1ceea09509f2f42a3'

export function initSettings(settings: SettingsService) {
  return () => settings.loadSettings()
}

export function createApollo(httpLink: HttpLink) {
  const basic = setContext(() => ({
    headers: {
      Accept: 'charset=utf-8',
    },
  }))

  const auth = setContext(() => {
    return {
      headers: {
        Authorization: `JWT ${token}`,
      },
    }
  })

  const link = ApolloLink.from([basic, auth, httpLink.create({ uri })])
  const cache = new InMemoryCache()

  return {
    link,
    cache,
  }
}

@NgModule({
  declarations: [AppComponent, PageComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: ':lang', component: PageComponent, canActivate: [HomeGuard] },
      { path: '', component: PageComponent },
    ]),
    NgxGoogleAnalyticsModule.forRoot('G-2Y5L2ZPK7Y'),
    NgxGoogleAnalyticsRouterModule,
  ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
    SettingsService,
    {
      provide: APP_INITIALIZER,
      useFactory: initSettings,
      deps: [SettingsService],
      multi: true,
    },
    Title,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
